import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=25ec04a6&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=25ec04a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec04a6",
  null
  
)

export default component.exports